import Navbar from "./components/Navbar";
import AuthProvider from "./context/AuthProvider";
import Main from "./Main";
import { BrowserRouter } from 'react-router-dom';
import { Box } from "@mui/material";

function App() {

  return (
/*
    <AuthProvider>
      <Main/>
    </AuthProvider>
*/
    <BrowserRouter>
      <AuthProvider>
        <Box
          sx={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
        <Navbar />
        <Box
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: "hidden",
            }}
          >
        <Main />
        </Box>
        </Box>
      </AuthProvider>
    </BrowserRouter>
  );

}

export default App;
